import { Home } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
// import LogoutIcon from "@mui/icons-material/Logout";

import BookIcon from "@mui/icons-material/Book";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import CancelIcon from "@mui/icons-material/Cancel";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import BookmarkIcon from "@mui/icons-material/Bookmark";

import HailIcon from "@mui/icons-material/Hail";

import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import VerifiedIcon from "@mui/icons-material/Verified";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

import CommuteIcon from "@mui/icons-material/Commute";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";

import NoTransferIcon from "@mui/icons-material/NoTransfer";

import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HandymanIcon from "@mui/icons-material/Handyman";
import ForumIcon from "@mui/icons-material/Forum";

import FeedbackIcon from "@mui/icons-material/Feedback";

import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";

import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import ShieldIcon from "@mui/icons-material/Shield";
import DiscountIcon from "@mui/icons-material/Discount";
import TuneIcon from "@mui/icons-material/Tune";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import PaymentsIcon from "@mui/icons-material/Payments";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ShareIcon from "@mui/icons-material/Share";
import PauseIcon from '@mui/icons-material/Pause';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupIcon from '@mui/icons-material/Group';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import EventIcon from '@mui/icons-material/Event';
import PinEndIcon from '@mui/icons-material/PinEnd';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocationCityIcon from '@mui/icons-material/LocationCity';
const menuItems = [
  {
    icon: <Home />,
    text: "Dashboard",
    path: "/main/dashboard",
    subMenuItems: [],
  },
  {
    icon: <BookmarkIcon />,
    text: "Bookings",
    path: "/main/bookings",
    subMenuItems: [
      { 
        icon: <BookIcon />, 
        text: "All Bookings", 
        path: "/main/bookings/all" 
      },
      {
        icon: <EventIcon />,
        text: "Upcoming Bookings",
        path: "/main/bookings/upcoming",
      },
      { icon: <BookIcon />, 
        text: "Ongoing Bookings", 
        path: "/main/bookings/live" 
      },
      {
        icon: <PinEndIcon />,
        text: "Ended Trips",
        path: "/main/bookings/endedtrips",
      },
      {
        icon: <CheckCircleIcon />,
        text: "Complete Trip",
        path: "/main/bookings/completetrip",
      },
      {
        icon: <ThumbDownIcon />,
        text: "Rejected",
        path: "/main/bookings/rejected",
      },
      {
        icon: <CancelIcon />,
        text: "Cancelled",
        path: "/main/bookings/cancelled",
      },
      {
        icon: <CreditCardOffIcon />,
        text: "Failed",
        path: "/main/bookings/failed",
      },
      {
        icon: <HistoryToggleOffIcon />,
        text: "History",
        path: "/main/bookings/history",
      },
      {
        icon: <CurrencyRupeeIcon />,
        text: "Earnings",
        path: "/main/bookings/totalearnings",
      },
    ],
  },
  {
    icon: <HailIcon />,
    text: "Customers",
    path: "/main/customer",

    subMenuItems: [
      {
        icon: <PersonIcon />,
        text: "Customers List",
        path: "/main/customers/all",
      },
      {
        icon: <HowToRegIcon />,
        text: "Pre-Registered Users",
        path: "/main/preregistered",
      },
      {
        icon: <PersonOffIcon />,
        text: "Blocked",
        path: "/main/customers/blocked",
      },
    ],
  },
  {
    icon: <ManageAccountsIcon />,
    text: "Hosts",
    path: "/main/host",

    subMenuItems: [
      { icon: <VerifiedIcon />, text: "Approve Hosts", path: "/main/host/approve" },
      { icon: <ScheduleIcon />, text: "Host Timings", path: "/main/bookings/hosttimings" },
      { icon: <PersonIcon />, text: "Host Details", path: "/main/host/details" },
      {
        icon: <CurrencyRupeeIcon />,
        text: "Vehicle Pricing",
        path: "/main/host/vehiclepricing",
      },
      {
        icon: <PersonOffIcon />,
        text: "Blocked Hosts",
        path: "/main/host/blocked",
      },
      {
        icon: <CurrencyRupeeIcon />,
        text: "Payouts",
        path: "/main/host/hostpayouts",
      },
      {
        icon: <LocalOfferIcon />,
        text: "Host Offers",
        path: "/main/host/offers",
      },
    ],
  },
  
  {
    icon: <GroupIcon />,
    text: "Agent",
    path: "/main/agent",
    subMenuItems: [
      {
        icon: <PersonAddAlt1Icon />,
        text: "Agent Management",
        path: "/main/agent/all",
      },
      {
        icon: <PaymentsIcon />,
        text: "Agent Payouts",
        path: "/main/agent/payments",
      }
    ],
  },


  {
    icon: <CommuteIcon />,
    text: "Vehicles",
    path: "/main/vehicles",

    subMenuItems: [
      {
        icon: <DriveEtaIcon />,
        text: "New Vehicles",
        path: "/main/vehicles/verify",
      },
      {
        icon: <ShareLocationIcon />,
        text: "Assign GPS",
        path: "/main/vehicles/assigngps",
      },
      {
        icon: <PauseIcon />,
        text: "Pause Vehicles",
        path: "/main/vehicles/pause",
      },

      {
        icon: <DriveEtaIcon />,
        text: "Live Vehicles",
        path: "/main/vehicles/list",
      },
      {
        icon: <NoTransferIcon />,
        text: "Blocked",
        path: "/main/vehicles/blocked",
      },
    ],
  },
  {
    icon: <CurrencyRupeeIcon />,
    text: "Payments",
    path: "/main/payments",

    subMenuItems: [
      {
        icon: <VerifiedIcon />,
        text: "Total Earnings",
        path: "/main/payments/totalearnings",
      },
      {
        icon: <PaymentsIcon />,
        text: "Hosts Earnings",
        path: "/main/payments/hostearnings",
      },
      {
        icon: <AccountBalanceWalletIcon />,
        text: "Refunds",
        path: "/main/payments/refunds",
      },
    ],
  },
  {
    icon: <SupportAgentIcon />,
    text: "Support",
    path: "/main/support",

    subMenuItems: [
      {
        icon: <ForumIcon />,
        text: "LiveChat",
        path: "/main/support/livechat",
      },
      {
        icon: <HandymanIcon />,
        text: "Mechanic",
        path: "/main/support/mechanic",
      },
    ],
  },
  {
    icon: <FeedbackIcon />,
    text: "Complaints",
    path: "/main/complaints",

    subMenuItems: [],
  },
  {
    icon: <LocalTaxiIcon />,
    text: "Vehicle Admin",
    path: "/main/vadmin",

    subMenuItems: [
      {
        icon: <HandymanIcon />,
        text: "Make",
        path: "/main/vadmin/vehiclemake",
      },
      {
        icon: <HandymanIcon />,
        text: "Model",
        path: "/main/vadmin/vehiclemodel",
      },
      {
        icon: <HandymanIcon />,
        text: "Category",
        path: "/main/vadmin/vehiclecategory",
      },
      {
        icon: <LocalGasStationIcon />,
        text: "FuelType",
        path: "/main/vadmin/vehicleFuelType",
      },
      {
        icon: <HandymanIcon />,
        text: "Trasmission",
        path: "/main/vadmin/vehicletransmission",
      },
      {
        icon: <PlaylistAddCheckCircleIcon />,
        text: "Features",
        path: "/main/vadmin/vehiclefeatures",
      },
      {
        icon: <LocationCityIcon />,
        text: "Cities",
        path: "/main/vadmin/cities",
      },
    ],
  },
  {
    icon: <TuneIcon />,
    text: "App Admin",
    path: "/main/aadmin",

    subMenuItems: [
      {
        icon: <DiscountIcon />,
        text: "Coupons",
        path: "/main/aadmin/coupons",
      },
      {
        icon: <ShareIcon/>,
        text: "Referral System",
        path: "/main/aadmin/referral",
      },
      {
        icon: <ShieldIcon />,
        text: "Protection Plans",
        path: "/main/aadmin/protectionplans",
      },
    ],
  },
];

export default menuItems;
